import { render } from "./ContenidoView.vue?vue&type=template&id=12a95242"
import script from "./ContenidoView.vue?vue&type=script&lang=js"
export * from "./ContenidoView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__